var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation3Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8333,
    cy: 15.8333,
    r: 15.8333,
    fill: "#FF9B21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 9.5V16.625",
    stroke: "#FEF4E6",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 22.1484V22.1643",
    stroke: "#FEF4E6",
    strokeWidth: 2.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation3Line);
export default __webpack_public_path__ + "static/media/information-3-line.c5f1a5c519621d05c9ea3562781eec39.svg";
export { ForwardRef as ReactComponent };